<template>
  <div class="home">
    <head>
      <meta charset="UTF-8" />
      <meta
        name="viewport"
        content="width=device-width, user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0"
      />
      <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
      <meta name="renderer" content="webkit" />
      <meta name="robots" content="all" />
      <meta property="wb:webmaster" content="1589f8e64ea3ca3a" />
      <title>绑定</title>
    </head>
    <div id="app">
      <div class="Page_page_36KxeD" v-if="show">
        <div class="Page_form_1oz39J">
          <div class="Page_title_2JTnMl">绑定手机</div>
          <!-- <div class="Page_subtitle_2bZDtM">应<a href="#">《互联网用户账号名称管理规定》</a>，需绑定手机后才能正常使用</div> -->
          <div class="LoginPage_group_2yR8T_">
            <label
              ><input
                class="LoginPage_input2_3ZL3IW"
                type="text"
                placeholder="手机"
                v-model="registerName"
            /></label>
          </div>
          <div class="LoginPage_group_2yR8T_ line">
            <label
              ><input
                class="LoginPage_input2_3ZL3IW code"
                type="text"
                placeholder="验证码"
                v-model="code"
            /></label>
            <el-button
              type="success"
              @click="countDown"
              :class="{ disabled: !this.canClick, codeBtn: true }"
            >
              {{ content }}
            </el-button>
          </div>
          <div class="LoginPage_group_2yR8T_">
            <div class="EyeInput_pw_w41ZtV">
              <input
                placeholder="密 码"
                type="password"
                class="LoginPage_input_yBbPhy"
                v-model="registerPass"
              />
              <div class="EyeInput_eye_2sCnS8"></div>
            </div>
          </div>
          <div @click="register" class="LoginPage_group_2yR8T_">
            <a
              href="javascript: void 0;"
              class="Button_button_9Gj_L9 Button_default_12cP_n"
              style="
                width: 308px;
                height: 40px;
                padding-left: 0px;
                padding-right: 0px;
              "
              >绑定</a
            >
          </div>
          <div class="LoginPage_help_1ZfQaR">
            <div class="LoginPage_r_uCZa1g">
              <a class="LoginPage_blue_lWh0mp" @click="gologin">登录</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import https from '../https.js'
import axios from 'axios'
export default {
  name: '',
  components: {},
  data() {
    return {
      show: false,
      registerName: '',
      code: '',
      registerPass: '',
      content: '发送验证码', // 按钮里显示的内容
      totalTime: 60, //记录具体倒计时时间
      canClick: true //添加canClick
    }
  },
  mounted() {
    this.isLogin()
  },
  methods: {
    isLogin() {
      const _this = this
      var openid = this.$route.query.openid || ''
      if (openid != '') {
        https
          .fetchGet('/api/WechatUser/WechatLogin', {
            openid: openid
          })
          .then((res) => {
            console.log(res.data)
            if (res.data.status == -1) {
              this.$message({
                type: 'error',
                message: '微信扫码已过期，请重新扫码',
                duration: 2000,
                onClose: function () {
                  _this.$router.push({ path: '/login' })
                }
              })
              //this.$router.push({ path: "/my" });
            }
            if(res.data.status == 0) {
              this.show = true
            }
            if(res.data.status == 1) {
              this.$router.push({ path: '/my' })
            }
          })
      }
    },
    countDown() {
      if (!this.canClick) return //改动的是这两行代码
      var reg = /^1[0-9]{10}$/
      if (!reg.test(this.registerName)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码',
          duration: 1000
        })
      } else {
        https
          .fetchGet('/api/User/GetPhoneVerifyCode', {
            PhoneNumber: this.registerName
          })
          .then((res) => {
            console.log(res.data)
            if (res.data == '发送成功') {
              this.canClick = false
              this.content = this.totalTime + 's后重新发送'
              const clock = window.setInterval(() => {
                this.totalTime--
                this.content = this.totalTime + 's后重新发送'
                if (this.totalTime < 0) {
                  window.clearInterval(clock)
                  this.content = '发送验证码'
                  this.totalTime = 10
                  this.canClick = true //这里重新开启
                }
              }, 1000)
            } else {
              this.$message({
                type: 'error',
                message: '手机号已注册，请到账户设置里面绑定',
                duration: 1000
              })
            }
          })
      }
    },

    gologin() {
      this.$router.push({ path: '/login' })
    },
    register() {
      var reg = /^1[0-9]{10}$/
      if (!reg.test(this.registerName)) {
        this.$message({
          type: 'error',
          message: '请输入正确的手机号码',
          duration: 1000
        })
      } else if (this.code.length <= 0) {
        this.$message({
          type: 'error',
          message: '验证码不能为空',
          duration: 1000
        })
      } else if (this.registerPass.length < 6) {
        this.$message({
          type: 'error',
          message: '密码不少于6位',
          duration: 1000
        })
      } else {
        https
          .fetchPost('/api/User/Register', {
            PhoneNumber: this.registerName,
            VerifyCode: this.code,
            Password: this.registerPass
          })
          .then((res) => {
            if (res.data.message.code == 200) {
              this.$message({
                type: 'success',
                message: '绑定成功',
                duration: 1000
              })
              this.$router.push({ path: '/my' })
            } else {
              this.$message({
                type: 'error',
                message: '绑定失败',
                duration: 1000
              })
            }
          })
      }
    }
  }
}
</script>
<style scoped>
#login_container {
  text-align: center;
}
.line {
  display: flex;
}
.line .code {
  width: 160px !important;
}
.codeBtn {
  color: white;
}
.disabled {
  background-color: #ddd;
  border-color: #ddd;
  color: #57a3f3;
  cursor: not-allowed;
}
.home,
#app {
  height: 100%;
}
.home {
  background: black;
}
label {
  width: 100%;
}
.Button_default_12cP_n {
  background-color: #286efa;
  color: #fff;
}
.LoginPage_blue_lWh0mp {
  color: #427afb;
  cursor: pointer;
  font-weight: 700;
}
.Button_button_9Gj_L9 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 30px;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 10px;
  padding-right: 10px;
  color: #333;
  border: #e9e9e9 1px solid;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.LoginPage_input_yBbPhy {
  width: 308px;
  height: 40px;
  line-height: 40px;
}
.LoginPage_input2_3ZL3IW {
  width: 100% !important;
  height: 40px;
  line-height: 40px;
}
.Page_form_1oz39J {
  padding: 30px 40px;
  background-color: #fff;
  width: 388px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.Page_title_2JTnMl {
  font-size: 36px;
  text-align: center;
  padding-bottom: 10px;
}
.Page_subtitle_2bZDtM {
  font-weight: bolder;
  text-align: center;
  padding-bottom: 30px;
  line-height: 170%;
}
.LoginPage_group_2yR8T_ {
  display: -webkit-box;
  display: -ms-flexbox;

  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 15px;
}
.LoginPage_help_1ZfQaR {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  line-height: 30px;
  justify-content: space-between;
}
* {
  box-sizing: border-box;
}
.coss {
  width: 10rem;
  height: 10rem;
  overflow: hidden;
  position: absolute;
  left: -20rem;
  top: 0;
}
*:before,
*:after {
  box-sizing: border-box;
}
*:focus {
  outline: 0 !important;
}

html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  font-family: "PingFangSC-Regular", "Microsoft YaHei", "Hiragino Sans GB",
    tahoma, Arial, "\5B8B\4F53", "STHeiti", "WenQuanYi Micro Hei", SimSun,
    sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
  font-family: "PingFangSC-Regular", "Microsoft YaHei", "Hiragino Sans GB",
    tahoma, Arial, "\5B8B\4F53", "STHeiti", "WenQuanYi Micro Hei", SimSun,
    sans-serif;
  font-size: 14px;
  line-height: 1;
  color: #333;
  background-color: #fff;
  word-wrap: break-word;
}

h1,
h2,
h3,
h4 {
  padding: 0;
  margin: 0;
}

input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

img {
  border: 0;
}

svg:not(:root) {
  overflow: hidden;
}

button,
input,
optgroup,
select,
textarea {
  color: inherit;
  font: inherit;
  margin: 0;
}

button {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled],
html input[disabled] {
  cursor: default;
}

button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
  cursor: pointer;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

input:-webkit-autofill {
  -webkit-box-shadow: 0 0 0px 1000px #fff inset;
  -webkit-text-fill-color: #333;
}

textarea {
  overflow: auto;
  resize: none;
  color: #333;
  padding: 10px;
  border: #e9e9e9 1px solid;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

optgroup {
  font-weight: bold;
}

a {
  color: inherit;
  text-decoration: none;
}

a:focus {
  outline: thin dotted;
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}

ul,
ol {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

p {
  margin: 0;
}

input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 10px;
  padding-right: 10px;
  color: #333;
  border: #e9e9e9 1px solid;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

textarea:focus,
input[type="text"]:focus,
input[type="password"]:focus {
  border-color: #a0bdfe;
  box-shadow: 0 0 3px 0 #427afb;
}

::placeholder {
  color: #9b9b9b;
}

.list-inline {
  font-size: 0;
}

.list-inline li {
  display: inline-block;
  font-size: 14px;
}

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 1em;
}

.link {
  color: #427afb;
  cursor: pointer;
}

.ReactModal__Body--open {
  overflow: hidden;
}

.container {
  width: 1180px;
  margin: 0 auto;
}

.modal-title {
  font-size: 20px;
  font-weight: normal;
  height: 60px;
  line-height: 60px;
  margin-top: 0;
  margin-bottom: 0;
  background: #f3f3f3;
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid #d8d8d8;
  padding-left: 20px;
}
.modal-foot {
  border-radius: 0 0 6px 6px;
  background: #f3f3f3;
  text-align: center;
  border-top: 1px solid #d8d8d8;
  height: 60px;
  padding-top: 12px;
}

.tether-element {
  z-index: 100000000000;
}

.modal-open {
  overflow: hidden;
}
.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
  height: 0;
}
.clearfix {
  zoom: 1;
}
.rc-pagination {
  font-size: 14px;
  display: flex;
  justify-content: center;
  width: 100%;
}
.rc-pagination-total-text {
  height: 30px;
  line-height: 30px;
  margin-right: 10px;
}
.rc-pagination:after {
  content: " ";
  display: block;
  height: 0;
  clear: both;
  overflow: hidden;
  visibility: hidden;
}
.rc-pagination-item {
  position: relative;
  cursor: pointer;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  list-style: none;
  background-color: #fff;
  margin-right: 8px;
  display: inline-block;
  padding-left: 6px;
  padding-right: 6px;
}
.rc-pagination-item a {
  text-decoration: none;
  color: #666;
}
.rc-pagination-item:hover {
  border-color: #427afb;
}
.rc-pagination-item:hover a {
  color: #427afb;
}
.rc-pagination-item-active {
  background-color: #427afb;
  border-color: #427afb;
}
.rc-pagination-item-active a {
  color: #fff;
}
.rc-pagination-item-active:hover a {
  color: #fff;
}
.rc-pagination-jump-prev:after,
.rc-pagination-jump-next:after {
  content: "\2022\2022\2022";
  display: block;
  letter-spacing: 2px;
  color: #ccc;
  font-size: 12px;
  margin-top: 1px;
}
.rc-pagination-jump-prev:hover:after,
.rc-pagination-jump-next:hover:after {
  color: #427afb;
}
.rc-pagination-jump-prev:hover:after {
  content: "\AB";
}
.rc-pagination-jump-next:hover:after {
  content: "\BB";
}
.rc-pagination-prev,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
  margin-right: 8px;
}
.rc-pagination-prev,
.rc-pagination-next,
.rc-pagination-jump-prev,
.rc-pagination-jump-next {
  position: relative;
  cursor: pointer;
  color: #666;
  font-size: 10px;
  list-style: none;
  min-width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
}
.rc-pagination-prev a:after {
  content: "\2039";
  display: block;
}
.rc-pagination-next a:after {
  content: "\203A";
  display: block;
}
.rc-pagination-prev,
.rc-pagination-next {
  font-size: 24px;
}
.rc-pagination-prev a,
.rc-pagination-next a {
  color: #666;
}
.rc-pagination-prev a:after,
.rc-pagination-next a:after {
  margin-top: -1px;
}
.rc-pagination-disabled {
  cursor: not-allowed;
}
.rc-pagination-disabled a {
  color: #ccc;
}
.rc-pagination-options {
  margin-left: 15px;
  color: #767676;
}
.rc-pagination-options-size-changer {
  width: 80px;
}
.rc-pagination-options-quick-jumper {
  margin-left: 16px;
  height: 30px;
  line-height: 30px;
}
.rc-pagination-options-quick-jumper input[type="text"] {
  margin: 0 8px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #c2c2c2;
  outline: none;
  padding: 3px 8px;
  width: 60px;
  height: 28px;
  line-height: 28px;
}
.rc-pagination-options-quick-jumper input:hover {
  border-color: #427afb;
}
.rc-pagination-simple .rc-pagination-prev,
.rc-pagination-simple .rc-pagination-next {
  border: none;
  height: 24px;
  line-height: 24px;
  margin: 0;
  font-size: 18px;
}
.rc-pagination-simple .rc-pagination-simple-pager {
  margin-right: 8px;
}
.rc-pagination-simple .rc-pagination-simple-pager .rc-pagination-slash {
  margin: 0 10px;
}
.rc-pagination-simple .rc-pagination-simple-pager input {
  margin: 0 8px;
  box-sizing: border-box;
  background-color: #fff;
  border-radius: 6px;
  border: 1px solid #d9d9d9;
  outline: none;
  padding: 5px 8px;
  width: 30px;
  min-height: 20px;
}
.rc-pagination-simple .rc-pagination-simple-pager input:hover {
  border-color: #427afb;
}
@media only screen and (max-width: 1024px) {
  .rc-pagination-item-after-jump-prev,
  .rc-pagination-item-before-jump-next {
    display: none;
  }
}
</style><style type="text/css">
/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */

/**
 * Remove the margin in all browsers.
 */

body {
  margin: 0;
}

/**
 * Render the `main` element consistently in IE.
 */

main {
  display: block;
}

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */

/**
 * Remove the gray background on active links in IE 10.
 */

a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10.
 */

img {
  border-style: none;
}

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input {
  /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select {
  /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */

textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary {
  display: list-item;
}

/* Misc
   ========================================================================== */

/**
 * Add the correct display in IE 10+.
 */

template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */

[hidden] {
  display: none;
}
</style>

